/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import {
  unsupportedBrowserPage,
  unsupportedBrowserRedirect,
} from '../../lib/ga/unsupported-browser.events';

import styles from './browser-support.module.scss';
import Chrome from '../../assets/icons/chrome.svg';
import Edge from '../../assets/icons/edge.svg';
import Safari from '../../assets/icons/safari.svg';
import Firefox from '../../assets/icons/firefox.svg';

const BrowserSupportComponent = () => {
  useEffect(() => {
    unsupportedBrowserPage();
  }, []);

  return (
    <div className={styles['unsupported-container']}>
      <div className={styles['content-container']}>
        <div className={styles['title']}>ZIPTEAMS</div>
        <div className={styles['sub-title']}>It’s not you, its us!</div>
        <div className={styles['desc']}>
          Zipteams currently works best in Chrome, Edge, Safari or Mozilla
          browsers. Please use one of these to continue.
        </div>
        <div className={styles['browsers']}>
          <IconButton
            onClick={() => {
              unsupportedBrowserRedirect('Chrome');
              window
                ?.open('https://www.google.com/intl/en_in/chrome/', '_blank')
                ?.focus();
            }}
          >
            <img src={Chrome} alt="chrome" className="w-9 lg:w-14" />
          </IconButton>
          <IconButton
            onClick={() => {
              window
                ?.open('https://www.microsoft.com/en-us/edge', '_blank')
                ?.focus();
              unsupportedBrowserRedirect('Edge');
            }}
          >
            <img src={Edge} alt="edge" className="w-9 lg:w-14" />
          </IconButton>
          <IconButton
            onClick={() => {
              window
                ?.open('https://support.apple.com/downloads/safari', '_blank')
                ?.focus();
              unsupportedBrowserRedirect('Safari');
            }}
          >
            <img src={Safari} alt="safari" className="w-9 lg:w-14" />
          </IconButton>
          <IconButton
            onClick={() => {
              unsupportedBrowserRedirect('Firefox');
              window
                ?.open('https://www.mozilla.org/en-US/firefox/new/', '_blank')
                ?.focus();
            }}
          >
            <img src={Firefox} alt="firefox" className="w-9 lg:w-14" />
          </IconButton>
        </div>
        {/* <Button
          variant="contained"
          color="primary"
          className={styles['okay-button']}
          onClick={() => {
            unsupportedBrowserOkay();
          }}
        >
          Okay
        </Button> */}
      </div>
    </div>
  );
};
export default BrowserSupportComponent;
